import { curry } from 'lodash';

export default curry((left, right, count) => (count === 1 ? left : right));
